import { useCallback } from 'react';
import { DEFAULT_LOCALE, DEFAULT_CURRENCY } from 'piramid-constants';
import { formatCurrencyAmount } from 'utils';

// Envuelve `formatCurrencyAmount` para que el mismo importe se vea igual en la
// app y en los PDFs de `packages/documents` (server components, sin hooks).
export const useNumberFormatter = (currency = DEFAULT_CURRENCY) => {
  const formatNumber = useCallback(
    (value?: any) =>
      value != null
        ? formatCurrencyAmount(value, currency, { locale: DEFAULT_LOCALE })
        : '',
    [currency],
  );

  return {
    formatNumber,
  };
};
